var _style, _g, _g2, _g3, _path, _path2, _path3, _path4, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path5, _path6, _path7, _path8, _path9, _path10, _g12, _g13, _g14, _g15, _path11, _path12, _g16, _g17, _g18, _g19, _path13, _path14, _g20, _g21, _g22, _g23, _g24, _g25, _path15, _path16, _path17, _g26, _g27, _g28, _g29, _path18, _g30, _g31, _g32, _g33, _path19, _g34, _g35, _g36, _g37, _g38, _g39, _path20, _g40, _path21, _g41, _g42, _path22, _g43, _g44;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4000 4000",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4600_10_07-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #67e9ff } \n\t\t.s1 { fill: #ff9a22 } \n\t\t.s2 { fill: #ffffff } \n\t\t.s3 { fill: #000072 } \n\t\t.s4 { fill: #ff6687 } \n\t\t.s5 { fill: #ff8095 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m4000 4000h-4000v-4000h4000z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1267.4 2618.9c0 0 38.3-46.5 0-105.2 0 0-102.7 33.2-60.6 171.8 30 98.8 120.6 149.7 169.9 170.7q0.1 0.1 0.1 0.1c19.7 8.3 32.7 11.9 32.7 11.9 0 0 42.8 142.3-142.1 150.4 0 0-338.8-133.7-343.2-450.6-4.4-316.9 246-466.6 485.3-363.3 179.2 77.4 216.4 463-142.1 414.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1376.8 2856.3c-0.8 8.5-16 109.9-16 109.9 0 0-277-87.6-301.4-380.5-19.4-233.4 203.1-324.1 315.8-237.1 111.9 86.4 56.7 292.6-107.8 270.3 0 0 38.3-46.5 0-105.2 0 0-102.7 33.2-60.6 171.8 30.1 98.9 120.8 149.8 170 170.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m973.7 2761.2c-29.1-54.8-48.4-118.9-49.5-193.2-4.4-316.9 246-466.6 485.3-363.3 111.5 48.2 167.9 215.4 108.6 323.4 19.9-96.7-31.6-214.6-119.8-252.7-224-96.7-458.5 43.4-454.4 340.1 0.8 54.2 12 102.7 29.8 145.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1280.9 2620.6c-4.5-0.5-8.9-1-13.5-1.7 0 0 6.7-8.2 11.7-22.1 1.9 8.5 2.3 16.5 1.8 23.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1409.5 2868.2c0 0 15.4 51.2-12.2 93.9 10.6-33.5 1-65.5 1-65.5 0 0-12.2-3.4-30.6-11.2-46.1-19.7-131-67.3-159.2-159.9-8.5-27.9-10.7-51.1-8.9-70.5 1.6 9.5 3.9 19.6 7.2 30.5 30.1 98.9 120.8 149.8 170 170.8 19.7 8.3 32.7 11.9 32.7 11.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1376.7 2856.2c-7.9-1.8-259.4-61-284-278.6-23.7-208.5 174.4-230.5 230.4-161 55.2 68.4 30.2 192-55.7 202.3 0 0 38.3-46.5 0-105.2 0 0-102.7 33.2-60.6 171.8 30 98.8 120.6 149.7 169.9 170.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1251 2524.2c0.3 0.4 0-0.1-0.2-0.3-0.2-0.3-0.5-0.7-0.8-1-0.5-0.7-1.1-1.4-1.8-2.1-1.3-1.5-2.8-2.9-4.4-4.2-1.6-1.3-3.2-2.5-5-3.6-1.7-1.3-3.6-2.1-5.5-3.1-7.7-3.8-16.8-5.7-26.6-5.7-9.8-0.6-20.1 1.8-30.7 4.1-5.2 1.6-10.6 2.9-16.1 4.5q-7.9 2.9-16.5 5.3l-0.4 0.1c-2.8 0.8-5.7-0.8-6.5-3.6-0.6-2 0-4 1.4-5.3q6.6-6.3 13.8-12.2c4.9-3.7 10.2-6.9 15.6-10.3 2.7-1.5 5.6-2.8 8.5-4.1 3-1.3 5.7-2.9 8.9-3.8l9.4-3c3.1-1 6.6-1.4 9.9-2.1 13.3-2.3 28-2 42.1 2.6 3.5 1.3 7 2.5 10.3 4.3 1.7 0.8 3.4 1.6 5 2.5l4.7 3.1c3.1 2.2 6.1 4.5 9 7.2 1.4 1.3 2.8 2.6 4.1 4.2 0.7 0.7 1.4 1.4 2.1 2.3 0.7 1 1.2 1.6 2.3 3.2 5.8 9 3.2 21-5.8 26.8-9 5.8-21 3.2-26.8-5.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m1267.3 3038c-2.4 0-4.8-0.5-7.1-1.4-3.6-1.4-88.7-35.4-175.4-109.7-115.8-99.3-178.1-223.3-179.9-358.6-2.2-156.8 57.9-287.7 165-359.2 99.5-66.4 226.1-74.5 347.3-22.1 105.1 45.3 168.5 188.5 135.7 306.4-13.3 47.7-60.9 149.3-224.9 149.3-19.5 0-40.5-1.4-63.3-4.5-6.9-1-12.9-5.6-15.4-12.2-2.6-6.5-1.4-13.9 3.1-19.4 0.9-1.2 22.7-29.3 6.6-67.5-22.8 14-60.7 51.7-33.7 140.7 38.6 126.8 187.9 169.4 189.4 169.8 6.4 1.8 11.5 6.7 13.4 13.1 0.8 2.6 18.6 63.6-17.3 114.1-26.7 37.6-74.7 58.2-142.6 61.2q-0.4 0-0.9 0zm-9-846.4c-60 0-117.3 16.7-166.8 49.8-96 64-149.9 183-147.9 326.3 4 283 291 415.8 327.2 431.3 52.8-3 89.3-17.9 108.2-44.4 18.1-25.2 16.3-56 13.9-71.3-39.3-13.4-166.2-65.8-204.7-192.2-47.1-154.9 72-195.4 73.2-195.8 8.3-2.7 17.4 0.5 22.2 7.8 24.7 37.8 22.9 74 14.1 99.6 156.4 12.1 203.6-68.6 217.8-119.7 27.5-98.7-26.7-222.9-113.6-260.4-47.9-20.7-96.6-31-143.6-31z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m2839.7 3408.7h-1604.7c-78.2-7.6-140.4-39.5-187-84.4q-0.2-0.1-0.2-0.1c-44.2-42.6-74.5-96.8-91.4-152.9-0.1 0-0.1-0.1-0.1-0.1-36.7-121.4-10.9-251.2 71.5-289.4 72.9-33.8 140.6 16.2 177 52.5 0.1 0.1 0.2 0.2 0.3 0.3 7.3 7.3 13.3 14 17.8 19.3q0.3 0.2 0.6 0.6c6 7.1 9.3 11.7 9.3 11.7 0.2-0.2 0.4-0.4 0.7-0.7 11.7-11.9 24.5-23 37.8-33.1 58.2-44.5 123.4-70.4 123.4-70.4h0.1c-0.1-1.9-0.1-3.8-0.1-5.7-2.5-159.4 42.1-315.9 76.4-412 11.8-32.9 22.4-58.7 29.4-75.2 5.7-13.3 9.1-20.5 9.1-20.5h1059c0 0 16.9 35.9 37.6 94.5 34.6 97.3 79.8 257.5 75.3 419.9 0 0 97.3 38.2 160.4 103.2 0 0 96.8-134.6 205-84.4 160.7 74.5 106.4 496.8-207.2 526.9z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2586.8 3040.8c-34 367.2-549.8 367.9-549.8 367.9 0 0-515.8-0.7-549.9-367.9-34-367.2 376.1-340.6 463.2-257.9 0 0-13.5-135.4 86.7-135.4 100.2 0 86.6 135.4 86.6 135.4 87.1-82.7 497.2-109.3 463.2 257.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1252.2 3353.2c-96.7 54.1-199.5-25.1-204.2-28.9q-0.2-0.1-0.2-0.1c-140-135-140.5-386.5-20-442.4 72.9-33.8 140.6 16.2 177 52.5 0.1 0.1 0.2 0.2 0.3 0.3 5.4 6.4 11.3 12.9 17.8 19.3q0.3 0.2 0.6 0.6c3.4 3.4 6.7 7.1 10 11 77.1 92.4 125.6 327.9 18.7 387.7z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2841.3 2965.5c3.2-3.9 6.6-7.6 10-11q0.3-0.4 0.5-0.6c6.5-6.4 12.4-12.9 17.8-19.3 0.1-0.1 0.2-0.2 0.3-0.3 36.5-36.3 104.2-86.3 177-52.5 120.5 55.9 120.1 307.4-19.9 442.4q0 0-0.2 0.1c-4.8 3.8-107.6 83-204.3 28.9-106.8-59.8-58.4-295.3 18.8-387.7z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1188.2 3154.4c12.3 41-2.8 81.8-33.8 91.1-31 9.3-66.1-16.4-78.4-57.5-12.3-41 2.8-81.8 33.8-91.1 31-9.3 66 16.4 78.4 57.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1198.1 3039.8c0.6 26.2-14.9 47.8-34.6 48.3-19.8 0.5-36.4-20.3-37-46.5-0.6-26.2 14.9-47.8 34.6-48.3 19.8-0.5 36.3 20.3 37 46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1059.2 3086.2c10.3 24.3 3.8 50.3-14.5 58.1-18.4 7.8-41.6-5.6-52-29.9-10.3-24.3-3.8-50.4 14.6-58.2 18.3-7.8 41.6 5.6 51.9 30z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1108.5 3012.3c10.3 24.4 3.8 50.4-14.6 58.2-18.3 7.8-41.6-5.6-51.9-30-10.3-24.3-3.8-50.3 14.5-58.1 18.4-7.8 41.6 5.6 52 29.9z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m2964.1 3096.9c31 9.3 46.1 50.1 33.8 91.1-12.3 41.1-47.4 66.8-78.4 57.5-31-9.3-46.1-50.1-33.8-91.1 12.4-41.1 47.5-66.8 78.4-57.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m2912.8 2993.3c19.8 0.5 35.3 22.1 34.6 48.3-0.6 26.2-17.2 47-36.9 46.5-19.8-0.5-35.3-22.1-34.7-48.3 0.7-26.2 17.2-47 37-46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m3066.6 3056.2c18.4 7.8 24.9 33.9 14.6 58.2-10.3 24.3-33.6 37.7-52 29.9-18.3-7.8-24.8-33.8-14.5-58.1 10.3-24.4 33.6-37.8 51.9-30z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m3017.4 2982.4c18.3 7.8 24.8 33.8 14.5 58.1-10.3 24.4-33.6 37.8-51.9 30-18.4-7.8-24.9-33.8-14.6-58.2 10.4-24.3 33.6-37.7 52-29.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2606.2 2443.1c-59 28.1-124 50.1-188.2 67.4-249.1 67-512.2 67-761.4 0-63.2-17-127.2-38.6-185.5-66.2 21.3-59.3 38.5-95.7 38.5-95.7h1059c0 0 16.9 35.9 37.6 94.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m3117.5 3171.3c-16.9 56.1-47.2 110.3-91.4 152.9q0 0-0.2 0.1c-46.6 44.9-108.8 76.8-187.1 84.4h-801.9-801.9c-78.2-7.6-140.4-39.5-187-84.4q-0.2-0.1-0.2-0.1c-44.2-42.6-74.5-96.8-91.4-152.9 3.1 4.8 122.1 183.1 232.3 125.8 88.6-46.2 124.4-202.6 29.2-343.4l14.9 12.5 38.5-33.8c0 0 81.4 252.4 201.4 233.9 113-17.3 69.3-440.1 69.3-440.1l406.5 141c0 0-5.8 248.2 88.4 248.2 94.3 0 88.4-248.2 88.4-248.2l406.5-141c0 0-43.6 422.8 69.4 440.1 120 18.5 201.4-233.9 201.4-233.9l38.5 33.8 14.9-12.5c-95.3 140.8-59.4 297.2 29.2 343.4 110.1 57.3 229.1-121 232.3-125.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1226 2966.2c107.5-89.6 180.9-114.8 223.4-120.3 13.9-1.8 20.3 16.7 8.4 24.1-115.2 71.5-196.7 148.6-196.7 148.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2812.8 3018.6c0 0-81.5-77.1-196.7-148.6-11.9-7.4-5.5-25.9 8.4-24.1 42.5 5.5 115.9 30.7 223.4 120.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1500.5 2369.1c-43.8 272.6-51.1 476.8-51.1 476.8l-43.5 10.4h-11.2c-2.5-159.4 42.1-315.9 76.4-412 11.8-32.9 22.4-58.7 29.4-75.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2602.8 2444.3c34.3 96.1 78.9 252.6 76.4 412h-11.3l-43.4-10.4c0 0-7.4-204.2-51.1-476.8 7 16.5 17.6 42.3 29.4 75.2z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1247.1 2953.2c1.7 1.9 2.8 3.2 4.1 4.7 1.2 1.5 2.3 3.1 3.5 4.6 2.3 3 4.3 6 6.4 9.1 4 6.2 7.9 12.5 11.2 19 7 12.9 12.8 26.2 17.6 39.8 4.7 13.7 8.7 27.6 11.2 41.7 2.7 14.1 4 28.4 4 42.6 0 1.9-1.5 3.4-3.4 3.4-1.3 0-2.4-0.7-3-1.8l-0.1-0.2c-3.1-6.4-5.7-12.8-8.6-19-3.1-6.2-5.7-12.5-8.8-18.5-5.8-12.3-12.4-24-18.8-35.7-6.6-11.5-13.8-22.7-21.1-33.5q-5.6-8.1-11.4-15.8l-5.9-7.5-2.9-3.6-2.6-3.2-0.7-0.9c-6.9-8.2-5.7-20.4 2.5-27.2 8-6.7 19.9-5.7 26.8 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2856.3 2979.3l-2.7 3.2-2.9 3.6-5.8 7.5q-5.9 7.7-11.4 15.8c-7.4 10.8-14.6 22-21.2 33.5-6.4 11.7-13 23.4-18.7 35.7-3.2 6-5.8 12.3-8.8 18.5-3 6.2-5.5 12.6-8.7 19l-0.1 0.1c-0.8 1.7-2.8 2.4-4.5 1.5-1.2-0.5-1.9-1.7-1.9-3 0.1-14.2 1.4-28.5 4.1-42.6 2.5-14.1 6.4-28 11.2-41.7 4.7-13.6 10.6-26.9 17.5-39.8 3.4-6.5 7.2-12.8 11.2-19 2.1-3.1 4.2-6.1 6.5-9.1 1.1-1.5 2.2-3.1 3.5-4.6 1.2-1.5 2.3-2.8 4-4.7 7.2-8 19.4-8.7 27.4-1.6 7.8 7 8.6 18.8 2 26.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1388.9 2843.5c5.2-1.6 10.7-2.6 16.2-3.4 5.5-0.8 11-1.2 16.7-1.5 11.2-0.4 22.6-0.2 34.5 1.8 2.1 0.4 3.6 2.5 3.2 4.6-0.2 0.9-0.6 1.7-1.3 2.3l-0.1 0.1c-9 8.1-18.4 14.2-28 19.9-4.8 2.7-9.6 5.3-14.5 7.6-4.9 2.3-9.9 4.3-15.1 5.6l-0.8 0.2c-10.4 2.7-21-3.5-23.6-13.8-2.6-10 3.1-20.2 12.8-23.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2674.3 2880.5c-5.2-1.3-10.2-3.3-15.1-5.6-5-2.3-9.8-4.9-14.6-7.6-9.5-5.7-19-11.8-28-19.9l-0.1-0.1c-1.6-1.5-1.7-4-0.3-5.6 0.6-0.7 1.4-1.1 2.3-1.3 11.8-2 23.2-2.2 34.5-1.8 5.6 0.3 11.2 0.7 16.7 1.5 5.5 0.8 10.9 1.8 16.1 3.4 10.2 3.3 15.9 14.2 12.6 24.4-3.2 9.8-13.4 15.4-23.3 12.9z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m2839.7 3428h-1604.7q-0.9 0-1.8 0c-191.9-18.4-285.4-173.3-307.1-300.3-20.8-122 16.8-227.9 93.6-263.5 96.9-44.9 182.3 36 214.9 73.4 50.7-45.8 114.1-76.6 140.6-88.3-1.8-256.6 112-498.7 116.9-509 3.3-6.8 10.1-11.1 17.5-11.1h1059c7.5 0 14.3 4.4 17.5 11.1 4.9 10.4 118 253.1 115.1 509.9 26.3 11.7 88.6 41.9 139 87.4 32.6-37.4 117.9-118.3 214.9-73.4 76.8 35.6 114.4 141.5 93.5 263.5-21.7 127-115.1 281.9-307 300.3q-1 0-1.9 0zm-1603.7-38.7h1602.8c169.5-16.7 252.2-154.8 271.6-268.1 17.6-102.9-11.9-194.1-71.6-221.8-92.3-42.8-180.2 77-181.1 78.2-3.4 4.6-8.6 7.5-14.3 8-5.7 0.4-11.4-1.7-15.4-5.9-59.4-61.1-152.6-98.3-153.6-98.7-7.5-3-12.5-10.4-12.2-18.6 6-222.3-83.8-443.1-106.2-494.4h-1033.8c-22.5 51.2-113.1 271.7-108.1 493.6 0.1 5.2-1.8 10.3-5.5 14-2.1 2.1-4.7 3.8-7.4 4.7-8.8 3.6-97.8 41-154.5 99.4-4 4.2-9.6 6.3-15.3 5.9-5.8-0.5-11-3.4-14.3-8.1-0.9-1.1-88.8-120.9-181.1-78.1-59.8 27.7-89.2 118.9-71.7 221.8 19.4 113.3 102.2 251.4 271.7 268.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1950.3 2782.9c0 0-0.1 4.3-0.3 12.3l-0.1 6.6c-1.9 91.4-10.1 485.4-14.1 560.7-0.1 3.9-0.6 7.7-1.5 11.3-15.4 74.1-142.3 76.2-207.9 76.2-68.7 0-239.1 1.3-239.3-92 0-13.9 2.1-26.3 5.7-37.3 21.9-66.7 100.6-80.2 106.3-81.2 0.1 0 0.3 0 0.3 0-45.8-280.7-61.3-576.2-61.3-576.2 0 0 135.2-35.5 250.4 0 45.4 14 80.1 35.5 105.5 56.5h0.1c31.2 25.8 48.5 50.7 54.1 59.7 1.4 2.2 2.1 3.4 2.1 3.4z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1934.3 3373.8c-15.4 74.1-142.3 76.2-207.9 76.2-68.7 0-239.1 1.3-239.3-92-0.1-99.1 105.4-117.4 112-118.5 0.1 0 0.3 0 0.3 0 0 0 268-22.5 334.9 134.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1950 2795.2l-0.1 6.6c-1.9 91.4-10.1 485.4-14.1 560.7-0.1 3.9-0.6 7.7-1.5 11.3-15.4 74.1-142.3 76.2-207.9 76.2-68.7 0-239.1 1.3-239.3-92 0-13.9 2.1-26.3 5.7-37.3q0.1 0 0.1 0c0 0 10.8 69.4 169.3 69.4 158.4 0 191.7-59 191.1-103.7-0.4-35.1 16.6-365 23.9-505.2 2-39.8 59-46.7 69.5-8.2q0.8 3.1 1.5 6.5 1.4 7.2 1.8 15.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1599.1 3239.5c0 0-66.6-488.7-66.6-547.4q0-0.9 0.1-1.7c0.3-28.6 42.2-30.8 45.9-2.5l71.5 550.5z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1596.2 3220.3c3.9-0.6 6.7-0.8 9.9-1q4.7-0.3 9.2-0.4c6.1-0.1 12.1 0 18.1 0.4 12 0.8 23.8 2.5 35.5 4.7 11.6 2.4 23.1 5.3 34.2 9.1 5.6 1.8 11.1 4 16.6 6.2 5.3 2.4 10.7 4.9 15.9 7.6 2.1 1.1 2.9 3.7 1.8 5.7-0.7 1.5-2.2 2.3-3.8 2.3h-0.1c-11.6-0.1-22.9-0.4-34.1-0.6-11.2-0.4-22.4-0.2-33.3-0.2-11 0.2-21.9 0.7-32.7 1.4-5.4 0.4-10.7 0.8-16 1.4q-3.9 0.3-7.8 0.8l-7 0.9-0.9 0.1c-10.7 1.4-20.4-6.1-21.8-16.7-1.3-10.5 5.9-20.1 16.3-21.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1607.9 3321.9c-2.3 20.9-3.9 41.1-3.3 60.3 0.2 9.6 1.5 18.8 2.9 27.7 1.5 9 4.2 17.2 6.7 25.4l0.4 1.3c3.1 10.2-2.7 21-12.9 24.1-10 3-20.5-2.4-23.9-12.1-4-11.5-6.3-23.5-6.5-35.2-0.2-11.8 0.9-23.3 3.4-34.3 2.5-11 6.1-21.6 10.7-31.6 4.6-10 10.1-19.4 17.3-28 1-1.3 2.9-1.4 4.2-0.4 0.8 0.7 1.1 1.7 1 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1753.8 3321.9c-2.4 20.9-3.9 41.1-3.3 60.3 0.2 9.6 1.4 18.8 2.9 27.7 1.5 9 4.2 17.2 6.7 25.4l0.4 1.3c3.1 10.2-2.7 21-12.9 24.1-10 3-20.5-2.4-23.9-12.1-4.1-11.5-6.4-23.5-6.6-35.2-0.2-11.8 0.9-23.3 3.5-34.3 2.4-11 6-21.6 10.6-31.6 4.7-10 10.2-19.4 17.3-28 1.1-1.3 3-1.4 4.2-0.4 0.8 0.7 1.2 1.7 1.1 2.6z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1546.2 2662.9c4.8 23.8 8.5 47.7 11.7 71.6 3.2 23.9 5.9 47.9 8.3 71.9 4.7 47.9 10.2 95.8 15.5 143.6l8.5 71.8 9 71.6 9.4 71.5c1.5 11.9 3.2 23.8 5 35.7l4.9 35.7 0.3 1.8c1.3 9.9-5.6 19.1-15.5 20.4-0.4 0.1-0.8 0.1-1.1 0.1-2 0.4-5.3 1.1-8 1.8-2.9 0.7-5.8 1.5-8.6 2.5-5.7 1.8-11.3 3.9-16.7 6.3-10.9 4.8-20.9 10.9-29.6 18.1-8.7 7.2-15.8 15.7-21.1 25.1-5.1 9.4-8.6 19.8-10 30.9-0.2 2.8-0.7 5.5-0.7 8.4l-0.2 4.2v2.2l0.1 1.8 0.2 3.6c0.1 1.2 0.4 2.3 0.6 3.4 0.3 2.4 1.1 4.4 1.8 6.6 2.9 8.4 9.1 15.7 17.3 22.1 8.5 6.3 19 11.4 30.3 15.5 11.3 4.1 23.4 7.1 35.8 9.6 49.9 9.5 103.1 9.2 156.2 8.8 26.3-0.4 52.2-1.9 77.2-6 24.8-4.1 49.1-11.2 66.8-23.4 4.2-3.1 8.1-6.4 11.2-10.1 3-3.7 5.7-7.5 7.4-11.9 1.7-4.2 3.1-8.8 3.5-13.7 0.1-1.4 0.3-2.2 0.4-4l0.2-5 0.5-9.9c1.2-26.6 2.1-53.4 2.9-80.2l4.9-160.8c3.3-107.3 4-214.6 14.5-321.8 0.6-6.1 6.1-10.6 12.2-10 5.6 0.5 9.8 5.1 10.1 10.5 6.1 107.5 2.2 214.8 0.5 322.1l-3.3 161.1c-0.7 26.9-1.4 53.7-2.3 80.7l-0.4 10.2-0.2 5.1c0 1.6-0.3 4.1-0.5 6.1-0.7 8.4-2.9 17-6.2 25.1-3.2 8.2-8.2 15.6-13.6 22.3-5.5 6.6-11.8 12.1-18.4 17-13.2 9.3-27.3 15.8-41.3 20.4-14.1 4.6-28.2 7.8-42.2 10.2-28 4.6-55.8 6.2-83.2 6.6-54 0.4-108.9 1.2-164.7-9.3-13.9-2.7-27.9-6.2-41.9-11.3-13.9-5.1-27.9-11.7-40.9-21.5-12.9-9.8-25-23.8-30.9-40.8-1.4-4.3-2.8-8.5-3.4-12.9-0.3-2.1-0.8-4.3-1-6.5l-0.4-6.4-0.1-3.2 0.1-2.9 0.2-5.8c0.1-3.9 0.7-7.8 1.1-11.6 2-15.6 7.2-31.1 15-45.1 8-14 18.6-26.2 30.6-36.1 12.1-9.9 25.4-17.5 39.1-23.4q10.3-4.5 21-7.7c3.5-1.1 7.1-2.1 10.8-3 3.8-0.9 7-1.6 11.7-2.3l-16.3 22.3c-4.2-23.9-8.5-47.8-12-71.8l-5.5-36-4.8-36.1c-6.3-48.1-11.8-96.2-16.2-144.5-4.6-48.2-8.2-96.6-11.4-144.9l-1.9-36.3c-0.3-12.1-0.8-24.2-0.9-36.3-0.2-24.3 0.2-48.6 2.3-73 0.4-4.5 4.4-7.9 9-7.5 3.7 0.3 6.6 3.1 7.3 6.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m2125.8 2779.5c5.6-9 22.8-33.9 54-59.7h0.1c25.4-21 60.1-42.5 105.5-56.5 115.2-35.5 250.4 0 250.4 0 0 0-15.5 295.5-61.3 576.2 0 0 0.2 0 0.4 0 5.6 1 84.3 14.5 106.2 81.2 3.6 11 5.7 23.4 5.7 37.3-0.2 93.3-170.6 92-239.3 92-65.6 0-192.5-2.1-207.9-76.2-0.8-3.6-1.3-7.4-1.5-11.3-4-75.3-12.2-469.3-14.1-560.7l-0.1-6.6c-0.2-8-0.3-12.3-0.3-12.3 0 0 0.7-1.2 2.2-3.4z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2474.5 3239.5c0 0 0.2 0 0.4 0 6.5 1.1 112.1 19.4 111.9 118.5-0.2 93.3-170.6 92-239.3 92-65.6 0-192.5-2.1-207.9-76.2 66.9-156.8 334.9-134.3 334.9-134.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2125.8 2779.5q0.6-3.4 1.4-6.5c10.5-38.5 67.5-31.6 69.5 8.2 7.4 140.2 24.3 470.1 23.9 505.2-0.6 44.7 32.7 103.7 191.2 103.7 158.4 0 169.2-69.4 169.2-69.4q0 0 0.1 0c3.6 11 5.7 23.4 5.7 37.3-0.2 93.3-170.6 92-239.3 92-65.6 0-192.5-2.1-207.9-76.2-0.8-3.6-1.3-7.4-1.5-11.3-4-75.3-12.2-469.3-14.1-560.7l-0.1-6.6q0.5-8.5 1.9-15.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2423.9 3238.4l71.5-550.5c3.7-28.3 45.6-26.1 46 2.5q0 0.8 0 1.7c0 58.7-66.5 547.4-66.5 547.4z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2471.3 3258.6l-7-0.9q-3.8-0.5-7.8-0.8c-5.3-0.6-10.6-1-16-1.4-10.7-0.7-21.6-1.2-32.7-1.4-10.9 0-22.1-0.2-33.3 0.2-11.2 0.2-22.5 0.5-34.1 0.6h-0.1c-2.4 0-4.3-1.9-4.3-4.2 0-1.6 0.9-3.1 2.3-3.8 5.2-2.7 10.6-5.2 16-7.6 5.4-2.2 10.9-4.4 16.5-6.2 11.1-3.8 22.6-6.7 34.2-9.1 11.7-2.2 23.5-3.9 35.5-4.7 6-0.4 12-0.5 18.1-0.4q4.6 0.1 9.2 0.4c3.2 0.2 6 0.4 9.9 1 10.6 1.7 17.8 11.6 16.2 22.1-1.6 10.5-11.2 17.6-21.6 16.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2471.2 3319.5c7.2 8.6 12.7 18 17.3 28 4.6 10 8.2 20.6 10.7 31.6 2.5 11 3.6 22.5 3.4 34.3-0.2 11.7-2.5 23.7-6.5 35.2-3.5 10.1-14.6 15.4-24.7 11.9-9.8-3.5-15.1-14-12.1-23.9l0.4-1.3c2.5-8.2 5.2-16.4 6.7-25.4 1.4-8.9 2.7-18.1 2.9-27.7 0.6-19.2-1-39.4-3.3-60.3v-0.2c-0.2-1.6 1-3.1 2.6-3.3 1-0.1 2 0.4 2.6 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2325.4 3319.5c7.1 8.6 12.6 18 17.3 28 4.6 10 8.2 20.6 10.6 31.6 2.6 11 3.7 22.5 3.5 34.3-0.2 11.7-2.5 23.7-6.6 35.2-3.5 10.1-14.5 15.4-24.6 11.9-9.9-3.5-15.1-14-12.2-23.9l0.4-1.3c2.5-8.2 5.2-16.4 6.7-25.4 1.5-8.9 2.8-18.1 2.9-27.7 0.7-19.2-0.9-39.4-3.3-60.3v-0.2c-0.2-1.6 1-3.1 2.6-3.3 1.1-0.1 2 0.4 2.7 1.1z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2544 2663.7c2.1 24.4 2.5 48.7 2.3 73 0 12.1-0.6 24.2-0.9 36.3l-1.9 36.3c-3.2 48.3-6.8 96.7-11.4 144.9-4.4 48.3-9.9 96.4-16.2 144.5l-4.8 36.1-5.5 36c-3.5 24-7.7 47.9-11.9 71.8l-16.4-22.3c4.7 0.7 7.9 1.4 11.7 2.3 3.7 0.9 7.3 1.9 10.8 3q10.7 3.2 21 7.7c13.7 5.9 27.1 13.5 39.1 23.4 12 9.9 22.6 22.1 30.6 36.1 7.8 14 13 29.5 15.1 45.1 0.3 3.8 0.9 7.7 1.1 11.6l0.2 5.8v2.9l-0.1 3.2-0.4 6.4c-0.2 2.2-0.7 4.4-1 6.5-0.6 4.4-2 8.6-3.4 12.9-5.9 17-18 31-30.9 40.8-13 9.8-27 16.4-40.9 21.5-13.9 5.1-27.9 8.6-41.9 11.3-55.8 10.5-110.7 9.7-164.7 9.3-27.4-0.4-55.2-2-83.2-6.6-14-2.4-28.1-5.6-42.1-10.2-14.1-4.6-28.2-11.1-41.4-20.4-6.5-4.9-12.9-10.4-18.4-17-5.4-6.7-10.4-14.1-13.6-22.3-3.3-8.1-5.5-16.7-6.2-25.1-0.2-2-0.5-4.5-0.5-6.1l-0.2-5.1-0.4-10.2c-0.9-27-1.6-53.8-2.3-80.7l-3.3-161.1c-1.7-107.3-5.6-214.6 0.5-322.1 0.3-6.2 5.6-10.9 11.8-10.6 5.6 0.4 10 4.7 10.5 10.1 10.5 107.2 11.2 214.5 14.6 321.8l4.8 160.8c0.8 26.8 1.8 53.6 2.9 80.2l0.5 9.9 0.2 5c0.1 1.8 0.3 2.6 0.4 4 0.4 4.9 1.8 9.5 3.5 13.7 1.7 4.4 4.4 8.2 7.4 11.9 3.1 3.7 7 7 11.2 10.1 17.7 12.2 42.1 19.3 66.8 23.4 25 4.1 50.9 5.6 77.2 6 53.1 0.4 106.4 0.7 156.2-8.8 12.4-2.5 24.5-5.5 35.8-9.6 11.3-4.1 21.8-9.2 30.3-15.5 8.2-6.4 14.4-13.7 17.3-22.1 0.7-2.2 1.5-4.2 1.8-6.6 0.2-1.1 0.5-2.2 0.6-3.4l0.2-3.6 0.1-1.8v-2.2l-0.1-4.2c-0.1-2.9-0.6-5.6-0.8-8.4-1.4-11.1-4.9-21.5-10-30.9-5.3-9.4-12.4-17.9-21.1-25.1-8.7-7.2-18.7-13.3-29.6-18.1-5.4-2.4-11-4.5-16.7-6.3-2.8-1-5.7-1.8-8.6-2.5-2.7-0.7-6-1.4-8-1.8-9.9-0.7-17.4-9.4-16.7-19.4q0.1-0.6 0.1-1.1l0.3-1.8 4.9-35.7c1.8-11.9 3.5-23.8 5-35.7l9.4-71.5 9-71.6 8.5-71.8c5.3-47.8 10.8-95.7 15.5-143.6 2.4-24 5.1-48 8.3-71.9 3.2-23.9 6.9-47.8 11.7-71.6v-0.1c0.9-4.5 5.2-7.3 9.7-6.4 3.7 0.7 6.3 3.8 6.6 7.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m2854.5 2175.1c-90.6 135.3-260.8 199.2-430.8 239.5-126.5 29.9-255.9 44.6-385.1 44.1h-0.1c-129.3 0.5-258.7-14.2-385.1-44.1-170-40.3-339.5-104.9-430.9-239.5-181.2-266.8-16-461.9-16-461.9 6.7-112.7 25.7-210.6 53.5-295.5q0 0.1 0 0c-0.2-1.4-30.5-219.8-30.9-428.7-0.4-169.4 18.9-332.4 89.8-368.3 149.1-75.5 492.2 274.8 492.2 274.8 129.1-35.7 227.4-33 227.4-33q0 0 0.4 0c6.5-0.2 102.5-1.5 227.1 33q0 0 0.1 0c5.1-5.4 344.1-349.8 492.1-274.8 158.6 80.3 58.9 796.8 58.9 797 27.8 84.9 46.7 182.8 53.5 295.5 0 0 157.9 202.5-16.1 461.9z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2855.2 2175.1c-80.6 127.4-260.8 199.2-430.8 239.5-126.5 29.9-255.9 44.6-385.1 44.1h-0.4-0.4c-129.3 0.5-258.7-14.2-385.1-44.1-170-40.3-350.2-112.1-430.9-239.5-81.1-128.1-90-241.6-71.4-328.8 0-0.1 0 0 0 0 0.1-0.1 0 0 0 0 0 0 74.1-145.8 201.3-145.1 127.2 0.6 189.4 119.1 316.7 123.8 127.1 4.7 170.4-120 369.8-120 199.4 0 242.6 124.7 369.8 120 127.2-4.7 189.5-123.2 316.6-123.8 127.3-0.7 190.7 134.4 190.7 134.4 0 0 0 0 0 0.1 0 0 9.2-0.2 9.2-0.1 18.7 87.2 11.1 211.4-70 339.5z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1663.3 1334.4c-20.4-71.9 62.3-165.4 142.2-98.3 38 32 48.6 70 49.3 101 0.8 36-28.6 65.7-64.6 65.7-52.4-0.1-112.2-16.4-126.9-68.4z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2286.9 1402.8c-36 0-65.4-29.7-64.6-65.7 0.7-31 11.3-69 49.4-101 79.8-67.1 162.5 26.4 142.1 98.3-14.7 52-74.5 68.3-126.9 68.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2935.5 1900.9c-4.3 65.8-26.2 141.8-81 223.5-90.6 135.3-260.8 199.2-430.8 239.5-126.5 29.9-255.9 44.6-385.1 44.1h-0.1c-129.3 0.5-258.7-14.2-385.1-44.1-170-40.3-339.5-104.9-430.9-239.5-56.7-83.5-79.5-160-84-225.7 2.4-34.8 9.7-65.5 18.5-91.4 13.3 41.2 34.2 85.1 65.5 131.2 91.4 134.6 260.9 199.1 430.9 239.4 126.4 30 255.8 44.7 385.1 44.2h0.1c129.2 0.5 258.6-14.2 385.1-44.2 170-40.3 340.2-104.2 430.8-239.4 30.3-45.1 50.5-88.5 63.3-129.3 8.4 26.1 15.2 57 17.7 91.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2295 1950.2c-19.8 71.1-98.3 87.8-158.3 79 0 0-2.2 130.3-99.7 130.3-97.5 0-99.7-130.3-99.7-130.3-60 8.8-138.5-7.9-158.3-79-10.4-37.3 1.6-64 15.2-81 9.6-11.9 28.7-8.8 33.6 5.7 9.6 28 30 66.3 69.7 64.6 62.2-2.8 57.3-103.9 57.3-103.9h82.2 82.2c0 0-4.9 101.1 57.3 103.9 39.7 1.7 60.1-36.6 69.6-64.6 5-14.5 24-17.6 33.6-5.7 13.7 17 25.6 43.7 15.3 81z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2848.7 989c-11.3-160.7-43.3-328.6-128-320.2-160.7 16.1-391.5 247.6-391.5 247.6 35.9 11.1 53.4 22.6 61.3 32.4 8.4 10.4-2.5 25.4-15.2 21.2-117.2-38.2-283.8-47.5-326.2-49.3-22.5 12.7-67.1 23.8-119.2 28.2-47.5 4-89.8 1.5-115.3-5.7-38.7 6.8-77.6 15.6-112.1 26.8-12.8 4.2-23.6-10.8-15.2-21.2 7.9-9.8 25.3-21.3 61.2-32.4 0 0-230.8-231.5-391.4-247.6-84.8-8.4-116.7 159.5-128 320.2-0.4-169.4 18.9-332.4 89.8-368.3 149.1-75.5 492.2 274.8 492.2 274.8 129.1-35.7 227.4-33 227.4-33q0 0 0.4 0 0.3 0 0.3 0c0 0 98.3-2.7 227.5 33 0 0 343.1-350.3 492.1-274.8 70.9 35.9 90.2 198.9 89.9 368.3z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1576.6 1890.4c0 53.5-64.2 96.9-143.3 96.9-79.2 0-143.3-43.4-143.3-96.9 0-53.6 64.1-97 143.3-97 79.1 0 143.3 43.4 143.3 97z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m2644.4 1793.4c79.2 0 143.4 43.4 143.4 97 0 53.5-64.2 96.9-143.4 96.9-79.1 0-143.3-43.4-143.3-96.9 0-53.6 64.2-97 143.3-97z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m2137.8 2018.7c0 0-9.7 102.5-99.2 102.5-89.5 0-99.3-102.5-99.3-102.5 0 0 92.6-15.6 99.3-133.8 0 0 2.3 111.8 99.2 133.8z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m2038.6 2138.1c-83 0-112.2-77.1-116.1-117.8-0.9-8.9 5.3-16.8 14-18.3 3.1-0.6 79.4-15.5 85.2-118.1 0.5-9 8.2-15.9 17.2-15.9 9 0.2 16.4 7.5 16.6 16.5 0.1 4 3.5 99 86 117.7 8.3 1.8 14 9.6 13.1 18.1-3.8 40.7-33.1 117.8-116 117.8zm-80.1-107.6c5.7 24.5 24.2 73.8 80.1 73.8 55.6 0 74.2-49 80-73.6-40.5-14.1-65.3-43.9-79.8-74.7-21.6 46.4-58.9 66.4-80.3 74.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2138.4 2018.7c-9.8 88.5-99.5 102.5-99.5 102.5 0 0-89.8-14-99.6-102.5l33.7-12.7c0 0 9.9 74 65.9 74 55.9 0 65.8-74 65.8-74z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2055.4 1834.5c0.5 5.5 0.7 10.2 0.9 15.2q0.2 7.4 0 14.8c-0.3 9.8-1 19.7-2.3 29.5-1.3 9.9-3 19.7-5.3 29.5q-3.6 14.7-9.2 29.1c-4 9.6-8.6 19.1-14.2 28.1-5.9 9-12.7 17.5-20.5 25.2-8.1 7.5-17.1 14.2-27 19.4-9.9 4.9-20.4 9-31 11-10.7 2.5-21.3 3.1-31.8 3.3-5.2-0.1-10.1-0.3-15.2-0.6-5.1-0.6-10.1-0.8-15.2-1.7-10.1-1.4-20.3-4-30.3-7.2-10-3.5-19.8-8.1-28.9-14-9.2-5.8-17.5-13.2-24.3-21.7-6.8-8.6-12.2-18.2-15.8-28.1-1.9-5-3.1-10.1-4.2-15.1-0.9-5.2-1.6-10.2-1.9-15.3-0.4-10.3 0.2-20.2 3.1-30.2 0.8-2.7 3.6-4.3 6.3-3.5 1.8 0.6 3.2 2.1 3.5 3.9l0.1 0.5c3.6 17.4 9.4 34.3 17.9 48.1 8.5 14 19.6 25 33.1 32.7 6.7 3.9 14.1 7 21.8 9.3 7.8 2.1 15.9 3.9 24.3 4.6 4.1 0.6 8.4 0.6 12.6 0.9 4.3 0.1 8.6 0.2 12.8 0.2 8.1-0.4 16.2-1 23.7-3 15.2-3.5 28.4-11 39.5-21.4 5.4-5.4 10.3-11.5 14.6-18.2 4.2-6.8 8.1-14 11.3-21.7 6.3-15.4 10.7-32.1 13.5-49.4 1.4-8.6 2.6-17.3 3.3-26.1 0.3-4.4 0.6-8.8 0.8-13.1 0.2-4.3 0.3-9 0.3-12.8v-0.6c-0.1-9.4 7.4-17 16.7-17.1 8.9-0.1 16.3 6.8 17 15.5z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2057.8 1835.6c-0.1 9.4-0.4 18.7-0.7 28.1q-0.3 14.1-1 28.1-1.2 28.1-3 56.3-1.7 28.1-4 56.2c-1.6 18.7-3.9 37.5-8.2 56.2-0.3 1.3-1.6 2.1-2.9 1.8-0.9-0.2-1.6-0.9-1.8-1.8-4.3-18.7-6.5-37.5-8.2-56.2q-2.3-28.1-4-56.2-1.7-28.2-3-56.3-0.6-14-1-28.1c-0.3-9.4-0.6-18.7-0.7-28.1-0.1-10.6 8.5-19.3 19.1-19.4 10.6-0.1 19.3 8.5 19.4 19.1 0 0.1 0 0.2 0 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1819 1632.3c8.4 99.2-43.8 184.6-116.6 190.7-72.7 6.1-138.5-69.3-146.9-168.5-8.3-99.2 43.9-184.6 116.6-190.7 72.8-6.2 138.6 69.3 146.9 168.5z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1766.7 1617.7c3 34.9-15.4 65-41.1 67.2-25.6 2.2-48.8-24.4-51.7-59.4-3-34.9 15.4-65 41.1-67.2 25.6-2.2 48.8 24.4 51.7 59.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1670.9 1733.6c1.2 14.2-6.3 26.4-16.7 27.3-10.4 0.8-19.8-10-21-24.2-1.2-14.2 6.2-26.4 16.7-27.3 10.4-0.8 19.8 10 21 24.2z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2168.4 1795.1c1 48-86.4 98-129.8 98-43.5 0-130.9-50-129.9-98 1-48 129.9-44 129.9-44 0 0 128.8-4 129.8 44z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2055.4 1836.7c0 3.8 0.1 8.5 0.3 12.8 0.2 4.3 0.5 8.7 0.9 13.1 0.6 8.8 1.8 17.5 3.2 26.1 2.8 17.3 7.3 34 13.5 49.4 3.3 7.7 7.1 14.9 11.3 21.7 4.3 6.7 9.2 12.8 14.6 18.2 11.1 10.4 24.3 17.9 39.5 21.4 7.5 2 15.6 2.6 23.7 3 4.2 0 8.6-0.1 12.8-0.2 4.2-0.3 8.5-0.3 12.6-0.9 8.4-0.7 16.5-2.5 24.3-4.6 7.7-2.3 15.1-5.4 21.8-9.3 13.5-7.7 24.6-18.7 33.1-32.7 8.5-13.8 14.3-30.7 17.9-48.1l0.1-0.5c0.6-2.8 3.2-4.5 6-4 1.9 0.4 3.3 1.8 3.8 3.6 3 10 3.5 19.9 3.1 30.2-0.2 5.1-1 10.1-1.8 15.3-1.2 5-2.4 10.1-4.3 15.1-3.6 9.9-8.9 19.5-15.7 28.1-6.9 8.5-15.2 15.9-24.3 21.7-9.2 5.9-19 10.5-29 14-10 3.2-20.1 5.8-30.3 7.2-5.1 0.9-10.1 1.1-15.2 1.7-5 0.3-10 0.5-15.1 0.6-10.5-0.2-21.2-0.8-31.8-3.3-10.7-2-21.1-6.1-31.1-11-9.9-5.2-18.8-11.9-26.9-19.4-7.9-7.7-14.7-16.2-20.6-25.2-5.6-9-10.2-18.5-14.1-28.1q-5.7-14.4-9.3-29.1c-2.3-9.8-4-19.6-5.3-29.5-1.3-9.8-1.9-19.7-2.2-29.5q-0.3-7.4 0-14.8c0.1-5 0.3-9.7 0.8-15.2 0.8-9.3 9-16.2 18.3-15.4 8.8 0.7 15.5 8.2 15.4 16.9z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1243.8 1413c2.7-11.1 6.4-21.3 10.3-31.7 4.1-10.2 8.5-20.3 13.4-30.2 5-9.9 10.2-19.8 16.4-29.1 6.2-9.3 13.1-18.3 21.5-26.1 1.2-1.1 3-1.1 4.1 0.1 0.6 0.7 0.8 1.5 0.7 2.4-1.7 11.3-4.2 21.8-6.8 32.3-2.5 10.5-5.6 20.7-8.5 31l-8.9 30.7c-3.1 10.1-6.3 20.4-9.8 30.1l-0.1 0.3c-3.2 8.8-12.9 13.3-21.7 10.1-8.2-2.9-12.6-11.7-10.6-19.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1815.2 911.9c-9.9 2.6-20.8 5.7-31.2 8.7-10.5 3.1-21.1 6.2-31.6 9.5-21.1 6.6-41.8 14.1-63.8 19.8h-0.1c-3.1 0.8-6.2-1-7-4-0.6-2.2 0.2-4.4 1.8-5.8 8.9-7.5 18.3-14.3 28.2-20.2 9.9-6 20.1-11.2 30.5-16.2q15.5-7.5 31.7-13.7c10.8-4.1 21.4-7.8 33.2-10.9 9-2.4 18.3 3 20.7 12 2.3 9-3 18.3-12.1 20.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2800.9 1422.5c-3.6-9.7-6.7-20-9.8-30.1l-8.9-30.7c-2.9-10.3-6-20.5-8.5-31-2.6-10.5-5.2-21-6.8-32.3-0.3-1.6 0.8-3 2.4-3.3 0.9-0.1 1.7 0.2 2.3 0.8 8.5 7.8 15.3 16.8 21.6 26.1 6.2 9.3 11.4 19.2 16.3 29.1 4.9 9.9 9.4 20 13.5 30.2 3.9 10.4 7.5 20.6 10.3 31.7 2.2 9-3.3 18.2-12.4 20.4-8.4 2.1-17-2.5-19.9-10.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2270.1 879.1c11.8 3.1 22.4 6.8 33.3 10.9q16.1 6.2 31.7 13.7c10.3 5 20.6 10.2 30.4 16.2 9.9 5.9 19.4 12.7 28.2 20.2 2.4 2 2.7 5.6 0.7 8-1.5 1.7-3.7 2.4-5.8 1.8h-0.1c-22.1-5.7-42.8-13.2-63.9-19.8-10.5-3.3-21-6.4-31.5-9.5-10.5-3-21.3-6.1-31.2-8.7l-0.4-0.1c-9-2.4-14.4-11.7-12-20.7 2.4-9 11.6-14.4 20.6-12z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2108.9 1784.9c0 7.8-31.6 14.1-70.6 14.1-39 0-70.6-6.3-70.6-14.1 0-7.8 31.6-14.1 70.6-14.1 39 0 70.6 6.3 70.6 14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2415.8 1463.8c72.8 6.1 125 91.5 116.6 190.7-8.4 99.2-74.1 174.6-146.9 168.5-72.8-6.1-125-91.5-116.6-190.7 8.4-99.2 74.2-174.7 146.9-168.5z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2373 1558.3c25.6 2.2 44 32.3 41.1 67.2-3 35-26.2 61.6-51.8 59.4-25.6-2.2-44-32.3-41.1-67.2 3-35 26.1-61.6 51.8-59.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2438.1 1709.4c10.4 0.9 17.9 13.1 16.7 27.3-1.2 14.2-10.6 25-21 24.2-10.5-0.9-17.9-13.1-16.7-27.3 1.2-14.2 10.6-25 21-24.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1331 1237.2c0 0-45.6-384.9 12-445.2 57.6-60.2 262.4 164.7 262.4 164.7-198.1 123.2-274.4 280.5-274.4 280.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1605.5 956.7c-114.2 71-187.9 153.3-229.9 210.3-9.6-102.7-24.8-321.2 11.4-382.6 81.4 21.9 218.5 172.3 218.5 172.3z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m1331 1254.1q-1.4 0-2.9-0.2c-7.3-1.3-13-7.2-13.9-14.7-0.1-1-11.5-98.1-15.7-201.3-8.6-214.7 22.2-246.9 32.3-257.5 9.9-10.4 23.4-15.7 39-15.5 82.3 1 231.4 162.1 248.1 180.4 3.4 3.8 5 8.8 4.3 13.7-0.7 5-3.6 9.4-7.8 12.1-191.3 118.9-267.5 272-268.2 273.5-2.9 5.9-8.8 9.5-15.2 9.5zm38-455.4c-8 0-11.7 2.8-13.8 5-33.8 35.4-26.9 234.9-12.8 381.1 35.9-54.4 110.3-148.7 236.8-231.4-51.1-53.6-157.7-154.1-209.8-154.7q-0.2 0-0.4 0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m2471.6 956.7c0 0 204.9-224.9 262.4-164.7 57.6 60.3 12.1 445.2 12.1 445.2 0 0-76.3-157.3-274.5-280.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2690.1 784.4c36.2 61.4 20.9 279.9 11.3 382.6-41.9-57-115.6-139.3-229.8-210.3 0 0 137-150.4 218.5-172.3z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m2746.1 1254.1c-6.4 0-12.4-3.6-15.2-9.5-0.8-1.5-77-154.6-268.2-273.5-4.3-2.7-7.1-7.1-7.8-12.1-0.7-4.9 0.8-9.9 4.2-13.7 16.7-18.3 165.8-179.4 248.1-180.4 15.8-0.2 29.2 5.1 39.1 15.5 10.1 10.6 40.9 42.8 32.2 257.5-4.1 103.2-15.5 200.3-15.6 201.3-0.9 7.5-6.6 13.4-14 14.7q-1.4 0.2-2.8 0.2zm-248.3-300.7c126.6 82.7 201 177 236.9 231.4 14.1-146.2 20.9-345.7-12.9-381.1-2.1-2.2-5.6-5.1-14.2-5-52.1 0.6-158.6 101.1-209.8 154.7z"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m2045.2 2475.7q-3.4 0-6.7 0c-131 0.5-261.8-14.5-389-44.7-140-33.2-338.1-94.8-441-246.4-97-142.8-96.2-266-78.4-344.2 16.2-71.7 48.8-119.1 59.8-133.5 6.7-105.4 24.5-203.2 52.8-290.8-3.6-27.4-25.1-194.4-29.7-367.3-6.9-261.3 25.2-406.2 98.3-443.2 68-34.5 175.6 2.8 319.7 110.6 87.2 65.3 162.3 137.9 185.1 160.4 122.2-32.4 214.3-31.2 222.4-31.1 8.2-0.1 100.2-1.3 222.5 31.1 22.7-22.5 97.9-95.1 185.1-160.4 144.1-107.8 251.7-145.1 319.7-110.6 73.1 37 105.3 182.3 98.2 444.1-4.7 174.7-26 339.1-29.7 366.5 28.4 87.7 46.2 185.6 52.9 291 10.2 14.5 41.6 63.3 57.1 136.2 16.9 78.9 17.4 202.2-75.7 341.2-101.5 151.2-300.3 213.1-441 246.4-125.1 29.7-253.7 44.7-382.4 44.7zm-6.8-33.9c128.5 0.7 256.8-14.1 381.4-43.7 135.2-32 325.9-91 420.7-232.4 69.2-103.1 93.1-208.7 71.1-313.7-16.5-78.8-54-127.9-54.4-128.4-2-2.7-3.3-6-3.5-9.4-6.3-105.9-24.1-203.9-52.7-291.2-0.8-2.4-1-5-0.7-7.6 0.3-1.8 25-180.3 29.9-367.6 8.5-319.1-46.3-395.1-79.7-412.1-113-57.2-378.7 176-472 271.2-3.9 4.3-9.9 6.3-15.8 5.2q-0.8-0.2-1.6-0.4c-125.3-34.5-221.1-32.4-222.1-32.3q-0.5 0-0.9 0c-1-0.1-97.6-2.1-222.5 32.4-6 1.6-12.3-0.1-16.6-4.5-93-95-359.3-328.9-472.4-271.6-33.5 17-88.3 93-79.8 412.2 5 186.3 29.7 365.7 30 367.5 0.3 2.6 0.1 5.3-0.8 7.8-28.6 87.2-46.3 185.1-52.7 291-0.2 3.7-1.6 7.2-3.9 9.9-0.4 0.5-39.5 47.7-56.7 125.4-23 103.7 1.8 210.1 73.8 316.2 96.3 141.8 286.2 200.5 420.8 232.4 124.6 29.6 252.8 44.4 381.1 43.7z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.755792e57dc4ac396ee6343179c31a03.svg";
export { ForwardRef as ReactComponent };